













import Vue from 'vue';
export default Vue.extend({
  name: 'ButtonLink',
  props: {
    onClick: {
      type: Function,
      default() {
        return () => {};
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onLinkClicked(evt: Event) {
      evt.preventDefault();
      this.$props.onClick(evt);
    },
  },
});
